@import '~style-sheet-helpers/core.less';
@import '../style.module.less';

.inventory-label {
  font-size: 12px;
  font-weight: 400;
}

.dropdown {
  margin-top: 4px;
}

.loading-indicator {
  height: 16px;
  width: 16px;
}
